import { CreditOfficer, Result } from "../models/interfaces";
import { BaseService } from "./BaseService";

export class CreditOfficerService extends BaseService {
  private url: string = "creditOfficers";

  async getCreditOfficers(params: {
    id?: number;
    name?: string;
    pageIndex?: number;
    pageCount?: number;
  }): Promise<Result<CreditOfficer[]>> {
    const queryParams = this.ToQueryString(params);
    return this.get(`${this.url}${queryParams}`);
  }

  async getCreditOfficer(id: number): Promise<Result<CreditOfficer>> {
    return this.get(`${this.url}/${id}`);
  }

  async addOrUpdateCreditOfficer(
    params: {
      name: string;
    },
    id?: number
  ): Promise<Result<CreditOfficer>> {
    if (id) {
      return this.put(`${this.url}/${id}`, params.name);
    } else {
      return this.post(`${this.url}`, params.name);
    }
  }

  async deleteCreditOfficer(id: number): Promise<Result<boolean>> {
    return this.delete(`${this.url}/${id}`);
  }
}

export default new CreditOfficerService();
